import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo, useContext } from 'react'

export interface Props {
  languagePrefix?: string
}

export const Toolbars = memo(function Toolbars({ languagePrefix }: Props) {
  const { languageCode } = useContext(HeaderContext) as any

  return (
    <Container dial={5} row stretch>
      <Item
        href={`https://www.simplebooking.it/ibe2/hotel/10529?lang=${languagePrefix || 'en'}`}
        rel="noopener"
        target="_blank"
      >
        {useVocabularyData('book', languageCode)}
      </Item>
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 50;
  transition: 0.3s ease-out;

  &.hidden {
    transform: translateY(6rem);
  }
`

const Item = styled.a`
  width: 100%;
  padding: 1.0625rem 1.375rem;
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.heading};
  background: ${({ theme }) => theme.colors.variants.primaryDark};
  color: ${({ theme }) => theme.colors.variants.neutralLight3};
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.75rem;
`
